'use strict';

import Analytics from '../../_common/js/modules/analytics';
import analyticsEvents from '../../_common/js/modules/analyticsEvents';
import announcementBar from '../../_common/js/modules/announcement';
import popupButtons from '../../_common/js/modules/popupButtons';
import gdprCookie from '../../_common/js/modules/gdprCookie';
import Cookies from '../../_common/js/modules/cookies';
import imageWrapper from '../../_common/js/modules/imageWrapper';
import imageWrapperHdm from './modules/imageWrapperHdm';
import intlPhoneInput from '../../_common/js/modules/intlPhoneInput';
import mediumZoom from '../../_common/js/modules/mediumZoom';
import modalWindow from '../../_common/js/modules/modalWindow';
import platformSelector from '../../_common/js/modules/platformSelector';
// import platformSelectBox from '../../_common/js/modules/platformSelectBox';
import pricing from '../../_common/js/modules/pricingFreshworks';
import partnerBadge from './modules/partnerBadge';
import mobileMenu from '../../_common/js/modules/mobileMenu';
import stickyMainMenu from '../../_common/js/modules/stickyMainMenu';
import userParams from '../../_common/js/modules/userParams';
import contactForm from '../../_common/js/modules/contactForm';
import themeCountdown from '../../_common/js/modules/themeCountdown';
import videoGuides from '../../_common/js/modules/videoGuides';
import sideNav from '../../_common/js/modules/sideNav';
import calculatorRoi from './modules/calculatorRoi';
import printArticle from './modules/printArticle';
import searchGtm from './modules/searchGtm';
import downloadChecklistPdf from './modules/downloadChecklistPdf';
import toggleButton from './modules/toggleButton';
import signUp from './modules/signUp';
import platformReadyToSwitch from './modules/platformReadyToSwitch';
import themeSearch from './modules/themeSearch';

( function( document, window ) {
    const analytics = Analytics();
    const cookiesGeneral = Cookies( 'HDM' );
    // Ready
    document.addEventListener( 'DOMContentLoaded', function() {
        const pageLang = document.documentElement.lang.split( '-' )[ 0 ];
        cookiesGeneral.create( 'lang', pageLang, '30d' );

        stickyMainMenu();
        mediumZoom();

        const calculatorForm = document.querySelector( '#calculator-form' );
        if ( calculatorForm ) {
            calculatorRoi();
        }

        const sideNavPage = document.querySelector( '.anchor-menu' ); // HDM Help, HDM Blog, Relokia Policy
        if ( sideNavPage ) {
            sideNav();
        }

        const zoomWrap = document.querySelector( '.zoom-default:not([hidden])' );
        if ( zoomWrap ) {
            imageWrapper();
        }

        const wpImage = document.querySelector( '[class*="wp-image-"]' );
        if ( wpImage && document.body.classList.contains( 'hdm-scheme' ) ) {
            imageWrapperHdm();
        }

        const platformList = document.querySelector( '.platform-list' );
        if ( platformList ) {
            platformSelector( cookiesGeneral );
        }

        // const platformSelectBoxList = document.querySelector( '.platform-select-list' );
        // if ( platformSelectBoxList ) {
        //     platformSelectBox( cookiesGeneral );
        // }

        const signUpForm = document.querySelector( '#sign-up-form' );
        if ( signUpForm ) {
            signUp();
        }

        const platformReadyToSwitchList = document.querySelector( '.ready-to-switch' );
        if ( platformReadyToSwitchList ) {
            platformReadyToSwitch( cookiesGeneral );
        }

        const phoneInputs = document.querySelectorAll( 'input[type=tel]' );
        if ( phoneInputs.length ) {
            intlPhoneInput( phoneInputs );
        }

        const chatBtn = document.querySelector( '.zendesk-btn' );
        const wizardBtn = document.querySelector( '.wizard-caption-btn' );
        const calendlyBtn = document.querySelector( '.calendly-btn' );
        if ( chatBtn || wizardBtn || calendlyBtn ) {
            popupButtons();
        }

        userParams( cookiesGeneral );

        const authorizedSolutionPartner = document.querySelector( '.authorized-solution-partner' );
        if ( authorizedSolutionPartner ) {
            partnerBadge();
        }

        const navMobile = document.querySelector( '*[data-bs-target="#navbarMobileMainMenu"]' );
        if ( navMobile ) {
            mobileMenu();
        }

        const announcementBarElement = document.querySelector( '.announcement-bar' );
        if ( announcementBarElement ) {
            announcementBar( cookiesGeneral, announcementBarElement );
        }

        const gdprCookieElement = document.getElementById( 'tuna_gdpr__cookie' );
        if ( gdprCookieElement ) {
            gdprCookie( cookiesGeneral, gdprCookieElement );
        }

        const modalVideoItem = document.querySelector( '#modalVideo' );
        if ( modalVideoItem ) {
            modalWindow();
        }

        const themeCountdownItem = document.querySelector( '#theme-countdown' );
        if ( themeCountdownItem ) {
            themeCountdown();
        }

        const videoGuidesBtn = document.querySelector( '.show-all-video-posts' );
        if ( videoGuidesBtn ) {
            videoGuides();
        }

        const wpcf7Form = document.querySelector( '.wpcf7-form' );
        if ( wpcf7Form ) {
            contactForm();
        }

        const pricingForm = document.querySelector( '.pricing-form' );
        if ( pricingForm ) {
            pricing();
        }

        const eventBtns = document.querySelectorAll( '[data-ga-action]' );
        if ( eventBtns.length > 0 ) {
            analyticsEvents( analytics, eventBtns );
        }

        const printArticleButton = document.querySelector( '#export-as-pdf' );
        if ( printArticleButton ) {
            printArticle();
        }

        const searchGtmInput = document.querySelector( '.search-input-gtm' );
        if ( searchGtmInput ) {
            searchGtm();
        }

        const downloadChecklistButton = document.querySelector( '#pdf-btn' );
        if ( downloadChecklistButton ) {
            downloadChecklistPdf();
        }

        const toggleBtn = document.querySelector( '#toggleButton' );
        if ( toggleBtn ) {
            toggleButton( toggleBtn );
        }

        const themeSearchForm = document.querySelector( '.theme-search-from' );
        if ( themeSearchForm ) {
            themeSearch();
        }

        if ( document.querySelectorAll( '[data-bs-toggle="tooltip"]' ).length ) {
            const tooltipTriggerList = document.querySelectorAll( '[data-bs-toggle="tooltip"]' );
            const tooltips = [ ...tooltipTriggerList ].map( ( tooltipTriggerEl ) => new bootstrap.Tooltip( tooltipTriggerEl ) );

            tooltipTriggerList.forEach( ( tooltipTriggerEl, index ) => {
                tooltipTriggerEl.addEventListener( 'show.bs.tooltip', () => {
                    tooltips.forEach( ( tooltip, idx ) => {
                        if ( idx !== index ) {
                            tooltip.hide();
                        }
                    } );
                } );
            } );
        }
    } );
}( document, window ) );
